import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper, Chip, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ChatBot from './ChatBot';
import './Prescription.css';

const ADMIN_EMAIL = 'eltonokoth59@gmail.com';

const Prescription = () => {
    const [prescriptions, setPrescriptions] = useState([]);
    const email = localStorage.getItem('email');
    const navigate = useNavigate();

    // Redirect non-admin users
    useEffect(() => {
        if (email !== ADMIN_EMAIL) {
            navigate('/');
        }
    }, [email, navigate]);

    const fetchPrescriptions = async () => {
        try {
            const response = await fetch('https://joshmachapi.onrender.com/api/prescriptions');
            if (!response.ok) {
                throw new Error('Failed to fetch prescriptions');
            }
            const data = await response.json();
            setPrescriptions(data);
        } catch (error) {
            console.error('Error fetching prescriptions:', error);
        }
    };

    useEffect(() => {
        fetchPrescriptions();
    }, []);

    if (email !== ADMIN_EMAIL) return null;

    return (
        <Box className="prescriptions-page">
            <Box className="prescriptions-header">
                <Typography variant="h4" className="prescriptions-title">
                    Customer Prescriptions
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <Chip label={`${prescriptions.length} total`} color="primary" size="small" />
                </Box>
            </Box>

            {prescriptions.length === 0 ? (
                <Paper className="prescriptions-empty">
                    <Typography variant="h6">No prescriptions yet</Typography>
                    <Typography color="textSecondary">
                        Customer prescriptions will appear here once submitted.
                    </Typography>
                </Paper>
            ) : (
                <Paper className="prescriptions-table-wrapper" elevation={0}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>Customer Message</strong></TableCell>
                                <TableCell><strong>Email</strong></TableCell>
                                <TableCell><strong>Image</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {prescriptions.map((prescription) => (
                                <TableRow key={prescription.id} className="prescription-row">
                                    <TableCell>
                                        {prescription.customer_message || <em style={{color:'#999'}}>No message</em>}
                                    </TableCell>
                                    <TableCell>
                                        <a href={`mailto:${prescription.customer_email}`} className="prescription-email">
                                            {prescription.customer_email}
                                        </a>
                                    </TableCell>
                                    <TableCell>
                                        {prescription.image_path ? (
                                            <a href={prescription.image_path} target="_blank" rel="noopener noreferrer">
                                                <img src={prescription.image_path} alt="Prescription" className="prescriptionImage" />
                                            </a>
                                        ) : (
                                            <span style={{color:'#999'}}>No image</span>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            )}

            <ChatBot />
        </Box>
    );
};

export default Prescription;
